/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SubmissionStatus } from '../../../models/SubmissionStatus';
import { RoutePath } from '../../../shared/enums/RoutePath';

export default function usePaymentForm(submission) {
  const history = useHistory();
  const [isChangeStatusDialogOpen, setChangeStatusDialogOpen] = useState(false);
  const [revertStatusAction, setRevertStatusAction] = useState(null);

  const handleChangeStatusConfirm = () => {
    setChangeStatusDialogOpen(false);
    const params = {
      procedure: submission?.procedure,
      ...(submission?.initialSubmissionProcedure && {
        initialSubmissionProcedure: submission?.initialSubmissionProcedure,
      }),
    };
    history.push(RoutePath.generateRoutePath(RoutePath.PROCEDURE_SEARCH, params));
  };

  const handleChangeStatusCancel = () => {
    setChangeStatusDialogOpen(false);
    setRevertStatusAction(null);
  };

  const handleBackToDraftButton = () => {
    setRevertStatusAction(SubmissionStatus.DRAFT.id);
    setChangeStatusDialogOpen(true);
  };

  const handleBackToReadyToSignButton = () => {
    setRevertStatusAction(SubmissionStatus.READY_TO_SIGN.id);
    setChangeStatusDialogOpen(true);
  };

  return {
    handleBackToDraftButton,
    handleBackToReadyToSignButton,
    dialogStatusChange: {
      isOpen: isChangeStatusDialogOpen,
      confirm: handleChangeStatusConfirm,
      cancel: handleChangeStatusCancel,
      revertStatusAction,
    },
  };
}
